import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';

@NgModule({
  imports: [NzDrawerModule, RouterModule],
})
export class DrawerServiceModule {}
